import React, { Fragment, useState } from 'react';
import inputWithSubmitButton from '../../../common/hocs/withSubmitButton';
import InputTypes from '../../../common/components/InputTypes';
const SubmitInput = inputWithSubmitButton(InputTypes);

interface IProps {
    getGiftListContribute: Function;
    headerMessage: string;
    hasError: boolean;
    isLoading: boolean;
}

const GiftListSearchForm: React.FC<IProps> = ({ headerMessage, hasError, isLoading, getGiftListContribute }) => {
    const [inputValue, setInputValue] = useState<string>('');

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        getGiftListContribute(inputValue);
    };

    const updateInputValue = (e: React.ChangeEvent<HTMLFormElement>) => {
        setInputValue(e.target.value);
    };

    const bttnClass = isLoading ? 'search_button processing' : 'search_button';
    const inputProps = {
        onChange: updateInputValue,
        name: 'giftListCode',
        placeHolder: 'Enter gift list code',
        label: 'Enter gift list code',
        value: inputValue,
        layout: 'floating',
        error: "Sorry, we don't recognise this gift list code",
        showErrorMessage: hasError
    };

    const buttonProps = {
        onclick: handleSubmit,
        disabled: !inputValue,
        classes: bttnClass,
        value: 'Submit'
    };
    return (
        <Fragment>
            <div dangerouslySetInnerHTML={{ __html: headerMessage }} />
            <form className="c-searchForm" onSubmit={handleSubmit}>
                <div className="c-searchForm__input">
                    <SubmitInput
                        inputProps={inputProps}
                        buttonProps={buttonProps}
                    />
                </div>
            </form>
        </Fragment>
    );
};

export default GiftListSearchForm;
